import React from "react"
import ContentSection from "../../../../../../components/Habitacional/ContentSection"
import * as S from "./CompleteFormMIP.Style"
import { ReactComponent as DocumentIcon } from "../../../../../../assets/images/habitacional/documents-icon.svg";
import Button from "../../../../../../components/Habitacional/core/Button"

const CompleteFormDFI = ({ comunicatorId }) => {
    return (
        <S.ContainerCompleteFormDFI>
            <ContentSection illustration={<DocumentIcon height="316px" />} title="Tudo certo!" noPadding>
                <S.ContainerTextCompleteFormDFI>
                    <S.DescriptionDataCompleteFormDFI>
                        Seu pedido de indenização e os documentos foram recebidos. Agora, vamos analisar a documentação enviada.
                        Podemos entrar em contato por telefone ou e-mail para solicitar algum documento adicional, tudo bem?
                        <br />
                        <br />
                        Se tiver tudo certo com a documentação, temos um prazo de análise de até 30 dias, mas esperamos te retornar antes.
                        <br />
                        <br />
                        Guarde o número do pedido para acompanhar o andamento do processo.
                    </S.DescriptionDataCompleteFormDFI>
                </S.ContainerTextCompleteFormDFI>
            </ContentSection>

            <S.ContentNumberCompleteFormDFI>
                <S.TitleNumberCompleteFormDFI>
                    Número do pedido
                </S.TitleNumberCompleteFormDFI>
                <S.NumberCompleteFormDFI>
                    {comunicatorId}
                </S.NumberCompleteFormDFI>
            </S.ContentNumberCompleteFormDFI>

            <Button variant="primary" type="button">Acompanhar pedido</Button>

        </S.ContainerCompleteFormDFI>
    )
}

export default CompleteFormDFI